import * as Types from '../Constants/AllConstants';

// Reducer for fetching all permissions for a group (paginated)
export const GetGroupPermissionsReducer = (
  state = { pagedPermissions: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.GROUP_PERMISSIONS_LIST_REQUEST:
      return { ...state, loading: true };

    case Types.GROUP_PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        pagedPermissions: action.payload.content,
        pages: action.payload.page?.totalPages || 0,
        page: action.payload.page?.number || 0,
      };

    case Types.GROUP_PERMISSIONS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};


// Reducer for fetching all permissions for a group (non-paginated)
export const GetAllGroupPermissionsReducer = (
  state = { permissions: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.GROUP_PERMISSIONS_ALL_REQUEST:
      return { ...state, loading: true };
    case Types.GROUP_PERMISSIONS_ALL_SUCCESS:
      return { ...state, loading: false, permissions: action.payload };
    case Types.GROUP_PERMISSIONS_ALL_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer for creating a group permission
export const CreateGroupPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_PERMISSION_CREATE_REQUEST:
      return { loading: true };
    case Types.GROUP_PERMISSION_CREATE_SUCCESS:
      return { loading: false, success: true, permission: action.payload };
    case Types.GROUP_PERMISSION_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.GROUP_PERMISSION_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for creating multiple group permissions
export const CreateBulkGroupPermissionsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_PERMISSION_BULK_CREATE_REQUEST:
      return { loading: true };
    case Types.GROUP_PERMISSION_BULK_CREATE_SUCCESS:
      return { loading: false, success: true, permissions: action.payload };
    case Types.GROUP_PERMISSION_BULK_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.GROUP_PERMISSION_BULK_CREATE_RESET:
      return {};
    default:
      return state;
  }
};


// Reducer for revoking a single group permission
export const RevokeGroupPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_PERMISSION_REVOKE_REQUEST:
      return { loading: true };
    case Types.GROUP_PERMISSION_REVOKE_SUCCESS:
      return { loading: false, success: true };
    case Types.GROUP_PERMISSION_REVOKE_FAIL:
      return { loading: false, error: action.payload };
    case Types.GROUP_PERMISSION_REVOKE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for revoking multiple group permissions
export const RevokeBulkGroupPermissionsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GROUP_PERMISSION_BULK_REVOKE_REQUEST:
      return { loading: true };
    case Types.GROUP_PERMISSION_BULK_REVOKE_SUCCESS:
      return { loading: false, success: true };
    case Types.GROUP_PERMISSION_BULK_REVOKE_FAIL:
      return { loading: false, error: action.payload };
    case Types.GROUP_PERMISSION_BULK_REVOKE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for fetching unassigned permissions for a user
export const GetUnassignedPermissionsReducer = (
  state = { unassignedPermissions: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.GROUP_PERMISSION_UNASSIGNED_REQUEST:
      return { ...state, loading: true };
    case Types.GROUP_PERMISSION_UNASSIGNED_SUCCESS:
      return { ...state, loading: false, unassignedPermissions: action.payload };
    case Types.GROUP_PERMISSION_UNASSIGNED_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};